import Form from "react-bootstrap/Form";

let ENDPOINTS = [
  "Forestomach_Papilloma",
  "Kidney_Mineralization",
  "Liver_Vacuolization",
  "Liver_Inflammation",
  "Liver_Proliferation",
  "Thymus_Atrophy",
  "Spleen_Proliferation",
  "Bone marrow_Hyperplasia",
  "Liver_Necrosis",
  "Kidney_Hydronephrosis",
  "Liver_Focus",
  "Liver_Eosinophilic focus",
  "Lung_Hemorrhage",
  "Lung_Edema",
  "Prostate gland_Inflammation",
  "Spleen_Atrophy",
  "Skin_Papilloma",
  "Liver_Nodule",
  "Pituitary gland_Adenoma",
  "Systemic_Mortality",
  "Mammary gland_Fibroadenoma",
  "Adrenal gland_Hyperplasia",
  "Lung_Carcinoma",
  "Lung_Adenoma or carcinoma",
  "Liver_Carcinoma",
  "Uterus_Polyp",
  "Mammary gland_Carcinoma",
  "Liver_Adenoma or carcinoma",
  "Lung_Adenoma",
  "Eye_Adenoma",
  "Liver_Adenoma",
  "Liver_Hyperplasia",
  "Eye_Carcinoma",
  "Forestomach_Hyperplasia",
  "Pituitary gland_Hyperplasia",
  "Thyroid gland_Hyperplasia",
  "Thyroid gland_Adenoma",
  "Liver_Alteration",
  "Liver_Hypertrophy",
  "Skin_Tumor",
  "Lung_Hyperplasia",
  "Thyroid gland_Carcinoma",
  "Urinary bladder_Hyperplasia",
  "Liver_Hemangiosarcoma",
  "Skin_Sarcoma",
  "Circulatory system_Lymphoma",
  "Spleen_Hemangiosarcoma",
  "Testes_Atrophy",
  "Kidney_Inflammation",
  "Liver_Fatty change",
  "Skin_Carcinoma",
  "Liver_Cyst",
  "Uterus_Sarcoma",
  "Preputial gland_Carcinoma",
  "Kidney_Hyperplasia",
  "Spleen_Sarcoma",
  "Lung_Congestion",
  "Kidney_Adenoma",
  "Glandular stomach_Inflammation",
  "Adrenal gland_Pheochromocytoma",
  "Thyroid gland_Adenoma or carcinoma",
  "Liver_Pigmentation",
  "Pancreas_Adenoma",
  "Pancreas_Carcinoma",
  "Kidney_Pigmentation",
  "Spleen_Congestion",
  "Skin_Hyperkeratosis",
  "Glandular stomach_Ulcer",
  "Liver_Atrophy",
  "Liver_Congestion",
  "Spleen_Hemosiderosis",
  "Brain_Hemorrhage",
  "Urinary bladder_Inflammation",
  "Nasal cavity_Inflammation",
  "Nasal cavity_Metaplasia",
  "Nasal cavity_Hyperplasia",
  "Skin_Hyperplasia",
  "Hematopoietic system_Leukemia",
  "Mammary gland_Adenoma",
  "Lung_Infiltration",
  "Spleen_Hyperplasia",
  "Lymph node_Infiltration cellular",
  "Eye_Atrophy",
  "Lung_Inflammation",
  "Lymph node_Hyperplasia",
  "Nasal cavity_Atrophy",
  "Uterus_Hyperplasia",
  "Kidney_Necrosis",
  "Lung_Infiltration cellular",
  "Lung_Metaplasia",
  "Pancreas_Hyperplasia",
  "Liver_Angiectasis",
  "Lymph node_Pigmentation",
  "Skin_Inflammation",
  "Parathyroid gland_Hyperplasia",
  "Pancreas_Atrophy",
  "Kidney_Cyst",
  "Lung_Sarcoma",
  "Liver_Sarcoma",
  "All organs_Sarcoma",
  "Glandular stomach_Hyperplasia",
  "Liver_Cytoplasmic change",
  "Skin_Adenoma",
  "Forestomach_Hyperkeratosis",
  "Spleen_Hematopoiesis",
  "Eye_Cataract",
  "Intestine large_Inflammation",
  "Kidney_Dilatation",
  "Kidney_Carcinoma",
  "Liver_Fatty metamorphosis",
  "Mammary gland_Hyperplasia",
  "Pituitary gland_Carcinoma",
  "Forestomach_Inflammation",
  "Forestomach_Ulcer",
  "Eye_Hyperplasia",
  "Uterus_Carcinoma",
  "Salivary gland_Atrophy",
  "All organs_Mesothelioma",
  "Testes_Hyperplasia",
  "Ovary_Tumor",
  "Glandular stomach_Mineralization",
  "Kidney_Atrophy",
  "Intestine small_Carcinoma",
  "Eye_Inflammation",
  "Liver_Fibrosis",
  "Brain_Astrocytoma",
  "Trachea_Inflammation",
  "Spleen_Fibrosis",
  "Skin_Ulcer",
  "Skin_Keratoacanthoma",
  "Lymph node_Atrophy",
  "Kidney_Infarct",
  "Heart_Atrophy",
  "Adrenal gland_Carcinoma",
  "Adrenal gland_Adenoma",
  "Uterus_Tumor",
  "Thymus_Hyperplasia",
  "Bone_Sarcoma",
  "Adrenal gland_Atrophy",
  "Thyroid gland_Inflammation",
  "Skin_Hemangiosarcoma",
  "Adrenal gland_Hypertrophy",
  "Lymph node_Lymphoma",
  "Thyroid gland_Cyst",
  "Lymph node_Inflammation",
  "Lung_Pneumonia",
  "Adrenal gland_Vacuolization",
  "Spleen_Necrosis",
  "Ovary_Inflammation",
  "Peritoneum_Sarcoma",
  "Adrenal gland_Necrosis",
  "Pancreas_Inflammation",
  "Seminal vesicle_Inflammation",
  "Heart_Myopathy",
  "Clitoral gland_Inflammation",
  "Lymph node_Sarcoma",
  "Testes_Inflammation",
  "Adrenal gland_Angiectasis",
  "Preputial gland_Inflammation",
  "Heart_Inflammation",
  "Peritoneum_Necrosis",
  "Heart_Thrombosis",
  "Lymph node_Angiectasis",
  "Lymph node_Hemorrhage",
  "Pituitary gland_Cyst",
  "Prostate gland_Hyperplasia",
  "Peritoneum_Inflammation",
  "Thymus_Cyst",
  "Skin_Cyst",
  "Intestine small_Inflammation",
  "Ovary_Cyst",
  "Uterus_Inflammation",
  "Brain_Inflammation",
  "Lymph node_Carcinoma",
  "Lymph node_Infiltration",
  "Pancreas_Cyst",
  "Pituitary gland_Angiectasis",
  "Intestine large_Parasite",
  "Heart_Mineralization",
  "Heart_Fibrosis",
  "Lymph node_Congestion",
  "Salivary gland_Inflammation",
  "Intestine small_Hyperplasia",
  "Uterus_Cyst",
  "All organs_Lymphoma",
  "Peritoneum_Fatty necrosis",
  "Systemic_Body weight",
  "Liver_Absolute organ weight",
  "Spleen_Absolute organ weight",
  "Lung_Absolute organ weight",
  "Heart_Absolute organ weight",
  "Thymus_Absolute organ weight",
  "Liver_Relative to body weight",
  "Kidney_Absolute organ weight",
  "Testes_Absolute organ weight",
  "Kidney_Relative to body weight",
  "Hematology_Leukocytes",
  "Hematology_Reticulocytes",
  "Hematology_Hemoglobin",
  "Hematology_Platelets",
  "Hematology_Lymphocytes",
  "Hematology_Neutrophils",
  "Hematology_Hematocrit",
  "Hematology_Eosinophils",
  "Heart_Relative to body weight",
  "Brain_Relative to body weight",
  "Lung_Relative to body weight",
  "Thymus_Relative to body weight",
  "Testes_Relative to body weight",
  "Hematology_Monocyte",
  "Hematology_Mean corpuscular hemoglobin",
  "Hematology_Mean corpuscular volume",
  "Hematology_Nucleated erythrocyte",
  "Clinical chemistry_Creatinine",
  "Clinical chemistry_Urea nitrogen",
  "Clinical chemistry_Glucose",
  "Clinical chemistry_Protein",
  "Brain_Absolute organ weight",
  "Clinical chemistry_Aspartate aminotransferase",
  "Reproductive system_Spermatid heads",
  "Clinical chemistry_Albumin",
  "Hematology_Cholesterol",
  "Clinical chemistry_Alkaline phosphatase",
  "Clinical chemistry_Alanine aminotransferase",
  "Clinical chemistry_Albumin/globulin ratio",
  "Clinical chemistry_Sorbitol dehydrogenase",
  "Clinical chemistry_Lactate dehydrogenase",
  "Clinical chemistry_Bile acids",
  "Hematology_Basophils",
  "Clinical chemistry_Gamma-glutamyl transferase",
  "Clinical chemistry_Bilirubin",
  "Clinical chemistry_Sodium",
  "Clinical chemistry_Chloride",
  "Clinical chemistry_Potassium",
  "Clinical chemistry_Calcium",
  "Clinical chemistry_Phosphorus",
  "Hematology_Triglycerides",
  "Hematology_Phospholipids",
  "Hematology_Fibrinogen",
  "Hematology_Prothrombin time",
  "Hematology_Activated partial thromboplastin time",
  "Systemic_Body weight change",
];

let organ_map = {};
ENDPOINTS.map((e) => {
  let split_e = e.split("_");
  let organ = split_e[0];
  let endpoint = split_e[1];
  if (organ in organ_map) {
    organ_map[organ].push(endpoint);
  } else {
    organ_map[organ] = [endpoint];
  }
});

function EndpointInput({ organ, setOrgan, endpoint, setEndpoint }) {
  let getFirstEndpoint = (organ) => {
    let omap = organ_map[organ]?.sort();
    if (omap.length == 0) {
      return null;
    }
    return omap[0];
  };
  return [
    <Form.Group controlId="endpointForm.OrganInput">
      <Form.Label>
        <b>Organ</b>
      </Form.Label>
      <Form.Select
        type="text"
        value={organ}
        onChange={(e) => {
          setOrgan(e.target.value);
          setEndpoint(getFirstEndpoint(e.target.value));
        }}
      >
        <option value={null}></option>
        {Object.keys(organ_map)
          .sort()
          .map((k) => (
            <option value={k}>{k}</option>
          ))}
      </Form.Select>
    </Form.Group>,
    <Form.Group controlId="endpointForm.EndpointInput">
      <Form.Label>
        <b>Endpoint</b>
      </Form.Label>
      <Form.Select
        type="text"
        value={endpoint}
        onChange={(e) => setEndpoint(e.target.value)}
      >
        <option value={null}></option>
        {organ_map[organ]?.sort().map((endpoint) => (
          <option value={endpoint}>{endpoint}</option>
        ))}
      </Form.Select>
    </Form.Group>,
  ];
}
export default EndpointInput;
